import { useRouteLoaderData } from 'react-router';
import type { LangLayoutLoader } from '~/routes/($lang)';

export const useAuthWrapper = () => {
  const rootLoaderData = useRouteLoaderData<LangLayoutLoader>( 'routes/($lang)' );

  return rootLoaderData?.authWrapper;
}